import { type ReactNode } from 'react';

export type TenantWatermark = {
  children: ReactNode;
};

export function TenantWatermark(props: TenantWatermark) {
  const { children } = props;

  return children;
}
